export default ['Welcome back', 'Check-in', 'Complete']
